import React, { useState } from 'react';
import useSWR from 'swr';
import { URLS } from '../../services/urls';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { confirmDeletion } from '../../components/dletion';
import { useTranslation } from 'react-i18next';
import ManageStockForm from './components/ManageStockForm';
import { DEFAULT_PAGE_COUNT } from '../../components/utils/consts';
import LoaderPage from '../../components/LoaderPage';
import { formatDate, formatNumber, sumArray } from '../../components/utils/functions';
import BonDeSortie from './components/BonDeSortie';
import _, { sum } from 'lodash';
import { DatePicker } from 'react-responsive-calendar-picker';
import SupplyTicket from './components/SupplyTocket';
import PaginationComponent from '../../components/Pagination';
import CLoader from '../../components/Loader';
import { toast } from 'react-toastify';
import { API } from '../../services/axios';

const SellsHistory = ({ type, title, isSelledHistory }) => {
  const [search, setSearch] = useState('');
  const [toEdit, setToEdit] = useState();
  const [open, setOpen] = useState(false);
  const [toEditStock, setToEditStock] = useState();
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [changingStatus, setChangingStatus] = useState('');
  const [dates, setDates] = useState({
    checkin: new Date(moment().startOf('month').format('YYYY-MM-DD')),
    checkout: new Date(moment().endOf('month').format('YYYY-MM-DD')),
  });
  const [page, setPage] = useState(1);

  const { active_agency } = useSelector((state) => state.agencies);

  const {
    data: products,
    isLoading,
    mutate,
  } = useSWR(
    URLS.STOCKS.lists(
      active_agency?.id,
      search,
      page,
      `OUT${isSelledHistory ? '&for_sale=true' : ''}`,
      dates?.checkout
        ? `&created_at__gte=${formatDate(dates.checkin) + 'T00:00'}&created_at__lte=${
            formatDate(dates.checkout) + 'T23:59:59'
          }`
        : `&created_at=${formatDate(dates.checkin) + 'T23:59:59'}`
    )
  );

  const { t } = useTranslation();

  const handleShow = (item, obj) => {
    let toShow = {};
    toShow[item] = obj;
    setToEdit(toShow);
  };

  const handleChangePage = (event, page) => {
    if (page) {
      console.log(page);
      setPage(page);
    }
  };

  const handleClose = () => {
    window.$('.btn-close')?.click();
  };

  const handleSuccess = () => {
    setToEdit();
    mutate();
  };

  const handleEdit = (obj) => {
    setToEdit(obj);
  };

  const handleDelete = (obj) => {
    confirmDeletion(URLS.PRODUCTS.delete(obj.id), t, mutate);
  };

  const handleChangeInvoiceStatus = (id, status, invoiceRef) => {
    console.log(id, status, invoiceRef);
    setChangingStatus(id);
    const id2 = toast.loading('Changement de statut en cours...');

    // Get the invoice data {}
    API.get(URLS.SEARCH.invoices(active_agency?.id, invoiceRef, 1, ``)).then((resp) => {
      const {results} = resp.data;
      // MArk an appointment as Cancelled or completed
      API.patch(URLS.INVOICES.update(_.filter(results, (i) => i.reference === invoiceRef)[0].id), {
        status: status,
      })
        .then((resp) => {
          setChangingStatus('');
          toast.update(id2, {
            render:
              status === 'CANCELLED'
                ? 'La facture a bien été annulée!'
                : 'La facture a bien été marquéé comme payéé!',
            type: 'success',
            isLoading: false,
            autoClose: true,
          });
          if (handleClose) {
            handleClose();
          }
        }).catch((error) => {
          setChangingStatus('');
          toast.update(id2, {
            render: "Une erreur s'est produite, veuiller reéssayer",
            type: 'error',
            isLoading: false,
            autoClose: true,
          });
        });
    }).catch((error) => {
      console.log(error);
    });
    }

  return (
    <div className="row">
      <div className="col-12">
        <div className="=">
          <div className="card-body">
            <div className="row justify-content-between flex-row">
              <div className="col-md-6">
                <div>
                  <p className="text-uppercas h4">{title ?? 'Sorties de stock'}</p>
                  {/* <h3 className="text-uppercase">Historique des sorties de stock </h3> */}
                  {/* <p>Les sorties de stock representent les produits sortis pour utilisation.</p> */}
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  {!isSelledHistory && (
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light rounded-0 px-3"
                      data-bs-toggle="modal"
                      data-bs-target=".new-stock-modal-out"
                    >
                      {' '}
                      + Déstockage
                    </button>
                  )}
                  <div className="row">
                    <div className="col">
                      <div className="form search-form">
                        <i className="fa fa-search"></i>
                        <input
                          onChange={(e) => setSearch(e.target.value)}
                          type="text"
                          class="form-control form-input py-2"
                          placeholder="Ref produit, Designation, etc ..."
                        />
                      </div>
                    </div>
                    <div className="col-auto">
                      <div>
                        <div className=" position-relative" style={{ zIndex: '1' }}>
                          <DatePicker
                            dates={dates}
                            setDates={setDates}
                            open={open}
                            setOpen={setOpen}
                            normal={true}
                          >
                            <button
                              className="btn btn-primary rounded-"
                              onClick={() => setOpen(!open)}
                            >
                              Date du {dates.checkin && moment(dates.checkin).format('DD/MM/YYYY')}{' '}
                              {dates.checkout && 'au'}{' '}
                              {dates.checkout && moment(dates.checkout).format('DD/MM/YYYY')}
                            </button>
                          </DatePicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <p className="card-title-desc">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem aspernatur culpa animi. Veritatis doloremque earum, maiores, laboriosam deserunt voluptas magni provident ratione rerum a quasi quam sunt quisquam illo nam!
              </p> */}

            {/* Manage stock */}

            {!isSelledHistory && (
              <div
                className="modal fade new-stock-modal-out"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="myLargeModalLabel">
                        {'Nouvelle sortie de stock'}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <ManageStockForm
                        handleClose={handleClose}
                        onSuccess={handleSuccess}
                        toEdit={toEditStock}
                        side={'OUT'}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div>
              <div>
                <div
                  className="modal fade sell-ticket-modal"
                  tabIndex={-1}
                  role="dialog"
                  aria-labelledby={'ticketSell'}
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id={'ticketSell'}>
                          {'Détails de la vente'}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <SupplyTicket
                          handleClose={handleClose}
                          onSuccess={handleSuccess}
                          invoice={toEdit}
                          isSelledHistory={true}
                          side="IN"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="mb-0" />
              <div className="table-responsive">
                <table className="table align-middle table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      {/* <th className="text-uppercas">Référence</th> */}
                      <th className="text-uppercas">Date </th>
                      <th className="text-uppercas">Libellés</th>
                      {type !== 'SERVICES' ? (
                        <>
                          <th className="text-uppercas">
                            {isSelledHistory ? 'Qtés Vendues' : 'Quantité'}
                          </th>
                          {/* <th className="text-uppercas">
                            {isSelledHistory ? "PVU" : "Prix de vente"}
                          </th> */}
                          <th className="text-uppercas">
                            {isSelledHistory ? "Prix de Vente Total" : ""}
                          </th>
                          {/* <th className="text-uppercas">{isSelledHistory ? 'CMUP' : 'CMUP'}</th> */}
                          <th className="text-uppercas">Marge</th>
                          {/* <th className="text-uppercas">Stock</th> */}
                          {/* <th className="text-uppercas">Emplacement</th> */}
                        </>
                      ) : (
                        <>
                          <th className="text-uppercas">Prix</th>
                        </>
                      )}
                      <th className="text-uppercas">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {
                        JSON.stringify(_.groupBy(products?.results ?? [], 'designation' ))
                    } */}
                    {Object.keys(_.groupBy(products?.results ?? [], 'designation'))?.map(
                      (item, index) => (
                        <tr key={'itmo-' + index}>
                          <td>
                            {moment(
                              _.groupBy(products?.results ?? [], 'designation')[item][0]?.created_at
                            )?.format('DD/MM/YYYY')}{' '}
                            <span className="ms-3">
                              {moment(
                                _.groupBy(products?.results ?? [], 'designation')[item][0]
                                  ?.created_at
                              ).format('HH:mm')}
                            </span>{' '}
                          </td>
                          <td>{item}</td>

                          <td>
                            <span className="badge badge-soft-success">
                              {sumArray(
                                _.groupBy(products?.results ?? [], 'designation')[item]?.map(
                                  (i) => i.quantity
                                )
                              )}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-soft-success">
                              {formatNumber(
                                Number(
                                  sumArray(
                                    _.groupBy(products?.results ?? [], 'designation')[item]?.map(
                                      (i) => Number(i.sell_price) * Number(i.quantity)
                                    )
                                  )
                                ).toFixed(2)
                              )}{' '}
                              FCFA{' '}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-soft-success">
                              
                              {formatNumber(
                                sumArray(
                                  _.groupBy(products?.results ?? [], 'designation')[item]?.map(
                                    (i) =>
                                      (parseFloat(i.sell_price) - parseFloat(i.buy_price)) *
                                      parseFloat(i.quantity)
                                  )
                                )
                              )}{' '}
                              FCFA{' '}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2 justify-content-center">
                              
                            <Link
                                to="#"
                                //   onClick={() => setSelectedInvoice(item)}
                                onClick={() =>
                                  handleShow(
                                    item,
                                    _.groupBy(products?.results ?? [], 'designation')[item]
                                  )
                                }
                                title="Imprimer"
                                data-bs-toggle="modal"
                                data-bs-target=".sell-ticket-modal"
                                className="btn btn-primary btn-colapsed"
                              >
                                <i className="ri-printer-line"></i>
                                <span>Imprimer</span>
                              </Link>
                            {isSelledHistory && (
                              <button
                                disabled={changingStatus ===  _.groupBy(products?.results ?? [], 'designation')[item][0]
                                  ?.id}
                                onClick={() => handleChangeInvoiceStatus( _.groupBy(products?.results ?? [], 'designation')[item][0]
                                  ?.id, 'CANCELLED', item)}
                                type="button"
                                className="btn btn-danger waves-effect waves-light"
                                title='Annuler'
                              >
                                {changingStatus !== _.groupBy(products?.results ?? [], 'designation')[item][0]
                                  ?.id && <span className="my-auto">
                                  <span className="ri-close-circle-line"></span>
                                </span>}{' '}
                                {changingStatus === _.groupBy(products?.results ?? [], 'designation')[item][0]
                                  ?.id && <span className="ms-2 d-inline-flex">
                                  <CLoader show={true} />
                                </span>}
                              </button>
                            )}
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                <div>
                  <div
                    className="modal fade bon-sortie-modal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="myLargeInvoicdseModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-lg">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="myLargeInvoicdseModalLabel">
                            {'Facture ' + selectedInvoice?.reference}
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <BonDeSortie invoice={selectedInvoice} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>{isLoading && <LoaderPage />}</div>
              </div>
              <div className="d-flex">
                <div className="ms-auto">
                  <div>
                  <div className="pt-3">
                  {
                    products?.count > 0 && (
                      <PaginationComponent currentPage={page} handlePageChange={handleChangePage} totalPages={Math.ceil(products.count / DEFAULT_PAGE_COUNT) ?? 0} />
                    )
                  }
                </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellsHistory;
